import React, { useEffect, useState } from "react"
import { v4 as uuid } from "uuid"

import "./Payments.css"
import { PrimaryButton } from "src/pages/home/room-detail/sections/elements/Elements"
import { useSelector } from "react-redux"
import { RootState } from "src/store/store"
import { useGetReservacionByIdQuery } from "src/gql/schema"
import { useDate } from "src/shared/hooks/useDate"
import { minus, sum } from "src/shared/helpers/calculator"
import { RegisterPay } from "src/pages/reservaciones/inicio/components/RegisterPay/RegisterPay"
import Pago from "src/pages/reservaciones/reservaciones/drawer/asignacion-reservaciones-tab-pago/sections/Pago/Pago"
import { formatCurrency } from "src/shared/hooks/formatCurrency"
import { getCardLabel } from "src/shared/sections/payment/helpers/card"
import { isVisibleCardOrReference } from "src/shared/sections/payment/Payment.helpers"
import { formatText } from "src/shared/hooks/formatTextOpcions"
import { useProfile } from "src/shared/hooks/useProfile"
import { ItemMultiplePayment } from "src/pages/home/room-detail/sections/items/Items"
import useIsColaboradorActive from "src/shared/hooks/useIsColaboradorActive"
import { RoleNames } from "src/shared/hooks/useAuth"
import { useIVA } from "src/shared/hooks/useIVA"
import LabelFlexLines from "src/pages/reservaciones/reservaciones/drawer/asignacion-reservaciones-tab-pago/sections/LabelFlexLines"
import DescriptionDetailTarifas from "../../../../../../../../shared/components/data-display/description-detail-tarifas/DescriptionDetailTarifas"
import { useDesgloseReservasTarifas } from "src/shared/hooks/useMotorTarifas/useDesgloseReservasTarifas"
import DrawerAccordion from "src/shared/components/data-display/drawer-accordion/DrawerAccordion"
import Descuento from "src/pages/reservaciones/reservaciones/drawer/asignacion-reservaciones-tab-pago/sections/Descuento/Descuento"

const Payments = ({ isNoShow }: { isNoShow: boolean }) => {
    const { reservaSeleccionada } = useSelector((root: RootState) => root.roomDetails.reservada)

    const { diffDays } = useDate()
    const { rolName } = useProfile()
    const { InactiveModal, validateIsColabActive } = useIsColaboradorActive()

    const { data, refetch } = useGetReservacionByIdQuery({
        variables: {
            id: reservaSeleccionada?.reserva_id || "",
        },
    })
    const [reservaActualizada, setReservaActualizada] = useState<any>()
    const [totalPorPagar, setTotalPorPagar] = useState(0)
    const { getIVA } = useIVA()

    useEffect(() => {
        setReservaActualizada(data?.reservas[0])
    }, [data])

    useEffect(() => {
        const allPagos = [
            ...(reservaActualizada?.pagos || []),
            ...(reservaActualizada?.renta?.pagos || []),
        ].filter((pago, index, self) => self.findIndex((p) => p.pago_id === pago.pago_id) === index)
        setTotalPorPagar(
            minus(
                reservaActualizada?.total || 0,
                sum(
                    allPagos.flatMap((p) =>
                        p.detalles_pago?.map((detallePago) => detallePago?.subtotal || 0) || [0]
                    )
                )
            )
        )
    }, [reservaActualizada])

    const { desglose_tarifas_reservas } = useDesgloseReservasTarifas(reservaActualizada?.reservas_tarifas)

    const allPagos = [
        ...(reservaActualizada?.pagos || []),
        ...(reservaActualizada?.renta?.pagos || []),
    ].filter((pago, index, self) => self.findIndex((p) => p.pago_id === pago.pago_id) === index)

    const { UTCStringToLocalDate } = useDate()

    const [isRegistrarPagoModalOpen, setisRegistrarPagoModalOpen] = useState(false)
    const diasAlojamiento =
        diffDays(
            UTCStringToLocalDate(reservaActualizada?.fecha_entrada),
            UTCStringToLocalDate(reservaActualizada?.fecha_salida)
        ) || 1

    const descuentoAplicado = reservaActualizada?.descuento_aplicado ?? reservaSeleccionada?.descuento_aplicado

    const descuentos = [
        ...(descuentoAplicado
            ? [
                {
                    tipo: "Estancia" as const,
                    monto: descuentoAplicado.data_descuento?.monto_calculado || 0,
                    fecha: UTCStringToLocalDate(descuentoAplicado.fecha_registro),
                    nombre: descuentoAplicado.descuento?.nombre || "",
                },
            ]
            : []),
        ...(reservaActualizada?.extras
            ?.filter((extra) => extra?.descuento_aplicado)
            ?.map((extra) => ({
                tipo: "Extras" as const,
                monto:
                    extra.descuento_aplicado?.data_descuento?.monto_calculado || 0,
                fecha: UTCStringToLocalDate(
                    extra.descuento_aplicado?.fecha_registro
                ),
                nombre:
                    extra.descuento_aplicado?.descuento?.nombre || "",
            })) || []),
    ]

    const totalDescuento = sum(
        descuentos.map((descuento) => descuento.monto)
    )
 
    const totalEstancia = reservaActualizada?.subtotales?.total_habitacion || 0
    const totalPersonasExtra =  reservaActualizada?.subtotales?.total_personas_extra || 0
    const totalExperiencias =
        reservaActualizada?.subtotales?.total_experiencias || 0
    const totalImpuestos = getIVA(totalEstancia + totalPersonasExtra + totalExperiencias)
    const totalCuenta = sum([reservaActualizada?.total || 0, totalDescuento])
    
    const hasPersonasExtra = (reservaActualizada?.personas_extras || 0) > 0
    const hasExperiencias = totalExperiencias > 0
    const hasPendingPayment = totalPorPagar > 0
    const hasAnyExtra = hasPersonasExtra || hasExperiencias
    const hasBothExtras = hasPersonasExtra && hasExperiencias
    const hasPagos = allPagos.some(
        (p) => p?.detalles_pago && p.detalles_pago.length > 0
    )
    const hasDescuentos = descuentos.length > 0

    let paymentsListHeight = "calc(100dvh - 400px)" 

    if (isNoShow) {
        if (hasBothExtras) {
            paymentsListHeight = "calc(100dvh - 420px)"
        } else if (hasAnyExtra) {
            paymentsListHeight = "calc(100dvh - 500px)"
        }
    } else {
        if (hasBothExtras) {
            paymentsListHeight = hasPendingPayment ? "calc(100dvh - 490px)" : "calc(100dvh - 420px)"
        } else if (hasAnyExtra) {
            paymentsListHeight = hasPendingPayment ? "calc(100dvh - 470px)" : "calc(100dvh - 400px)"
        } else if (hasPendingPayment) {
            paymentsListHeight = "calc(100dvh - 450px)"
        }
    }

    return (
        <div className="tab__reservada__payments__container">
            <div
                className="tab__reservada__payments__list"
                style={{
                    height: paymentsListHeight,
                    overflowY: "auto",
                }}
            >
                <DrawerAccordion
                    title="Resumen de compra"
                    isEmpty={false}
                    emptyDescription="No hay descuentos registrados"
                    emptyIcon={"priceTag"}
                >
                    <DescriptionDetailTarifas
                        icon="BedFilled"
                        label="Estancia y tarifas"
                        style={{ width: "100%", padding: "12px 0" }}
                        tarifas={desglose_tarifas_reservas.map((d) => ({
                            nombre: d.nombre,
                            subtotal: d.subtotal,
                            dias: d.dias,
                            hospedaje: d.registros_finales.map((r) => ({
                                rango: r.rango,
                                costo: r.precio_unitario,
                            })),
                        }))}
                    />

                    {reservaActualizada?.personas_extras > 0 && (
                        <DescriptionDetailTarifas
                            icon="UserParentFill"
                            label="Personas extras"
                            style={{ width: "100%", padding: "12px 0" }}
                            tarifas={desglose_tarifas_reservas
                                .filter((d) =>
                                    d.registros.some((r) => (r.costo_persona_extra ?? 0) > 0)
                                )
                                .map((d) => {
                                    const personas = reservaActualizada?.personas_extras ?? 0

                                    const subtotal = d.registros.reduce((acc, r) => {
                                        return acc + ((r.costo_persona_extra ?? 0) * personas * r.noches)
                                    }, 0)

                                    return {
                                        nombre: d.nombre,
                                        subtotal,
                                        dias: d.dias,
                                        hospedaje: d.registros
                                            .filter((r) => (r.costo_persona_extra ?? 0) > 0)
                                            .map((r) => ({
                                                personas,
                                                costo: (r.costo_persona_extra ?? 0) * personas * r.noches,
                                                costo_individual: r.costo_persona_extra,
                                            })),
                                    }
                                })}
                        />
                    )}

                    {!!reservaActualizada?.experiencias_reserva?.length && (
                        <ItemMultiplePayment
                            showAmounts
                            icon="star"
                            label="Experiencias"
                            style={{ width: "100%", padding: "12px 0" }}
                            className="detalle-h-items__multiple--experience"
                            labelClass="detalle-h-items__multiple__text--experience"
                            payments={
                                reservaActualizada?.experiencias_reserva?.map((s) => ({
                                    label: s.experiencia?.nombre || "",
                                    amount: s.total ?? 0,
                                })) || []
                            }
                        />
                    )}
                </DrawerAccordion>
                <DrawerAccordion
                    title="Pagos registrados"
                    isEmpty={!hasPagos}
                    emptyDescription="No hay pagos registrados"
                    emptyIcon={"CoinsFill"}
                >
                    {isRegistrarPagoModalOpen && (
                        <RegisterPay
                            id={reservaActualizada?.reserva_id || ""}
                            onClose={() => {
                                refetch()
                                setisRegistrarPagoModalOpen(false)
                            }}
                        />
                    )}

                    {allPagos.map((p) =>
                        p?.detalles_pago?.map((detallePago) => (
                            <Pago
                                key={uuid()}
                                date={UTCStringToLocalDate(p.fecha_pago)}
                                isCard={isVisibleCardOrReference(detallePago?.tipo_pago)}
                                payType={formatText(detallePago.tipo_pago)}
                                total={detallePago.subtotal}
                                ultimos_digitos={getCardLabel(detallePago)}
                                parcialPay={detallePago.subtotal !== reservaActualizada?.total}
                                type={detallePago.tipo_pago || ""}
                            />
                        ))
                    )}
                </DrawerAccordion>
                <DrawerAccordion
                    title="Descuentos"
                    isEmpty={!hasDescuentos}
                    emptyDescription="No hay descuentos registrados"
                    emptyIcon={"priceTag"}
                >
                    {descuentos.map((descuento) => (
                        <Descuento
                            key={uuid()}
                            monto={descuento.monto}
                            fecha={descuento.fecha}
                            nombre={descuento.nombre}
                            tipo={descuento.tipo}
                        />
                    ))}
                </DrawerAccordion>
            </div>

            <div className="room-detail--reservada__tab--payments__footer">
                <div className="tab__reservada__payments__divider" />
                <LabelFlexLines
                    label1={`Estancia (${diasAlojamiento} ${diasAlojamiento > 1 ? 'noches' : 'noche'})`}
                    value1={formatCurrency(totalEstancia)}
                    style={{
                        fontWeight: 500,
                    }}
                />
                { hasPersonasExtra && (
                    <LabelFlexLines
                        label1={`Personas extra (${reservaActualizada?.personas_extras})`}
                        value1={formatCurrency(totalPersonasExtra)}
                        style={{
                            marginTop: "-5px",
                            fontWeight: 500,
                        }}
                    />
                )}
                { hasExperiencias && (
                    <LabelFlexLines
                        label1={`Experiencias (${reservaActualizada?.experiencias_reserva?.length})`}
                        value1={formatCurrency(totalExperiencias)}
                        style={{
                            marginTop: "-5px",
                            fontWeight: 500,
                        }}
                    />
                )}

                <LabelFlexLines
                    label1="Impuestos"
                    value1={formatCurrency(totalImpuestos)}
                    style={{
                        marginTop: "-5px",
                    }}
                />
                <LabelFlexLines
                    label1="Total de cuenta"
                    value1={formatCurrency(totalCuenta)}
                    style={{
                        marginTop: "-5px",
                        fontWeight: 500,
                    }}
                />
                
                <div className="tab__reservada__payments__divider" />
                <LabelFlexLines
                    label1="Descuentos"
                    value1={`${totalDescuento > 0 ? "-" : ""}${formatCurrency(totalDescuento)}`}
                />
                <LabelFlexLines
                    label1="Total pagado"
                    value1={(() => {
                        const total = sum(
                            allPagos.flatMap(
                                (p) => p.detalles_pago?.map((d) => d?.subtotal || 0) || [0]
                            )
                        )

                        return `${total > 0 ? "-" : ""}${formatCurrency(total)}`
                    })()}
                />

                <LabelFlexLines
                    label1="Por pagar"
                    value1={formatCurrency(Math.max(0, totalPorPagar))}
                    style={{ fontWeight: 700, fontSize: "20px" }}
                />
                {rolName !== RoleNames.valet && rolName !== RoleNames.monitoreo && totalPorPagar > 0 && (
                    <PrimaryButton
                        text="Registrar pago"
                        disabled={isNoShow}
                        onClick={validateIsColabActive(() => setisRegistrarPagoModalOpen(true))}
                    />
                )}
            </div>

            {InactiveModal}
        </div>
    )
}

export default Payments
